// zeynepjs initialization for demo
$(function () {
  var zeynep = $(".zeynep").zeynep({
    opened: function () {
      //console.log('the side menu is opened')
    },
  });

  // dynamically bind 'closing' event
  zeynep.on("closing", function () {
    //console.log('this event is dynamically binded')
  });

  // handle zeynepjs overlay click
  $(".zeynep-overlay, .menu-close-btn").on("click", function () {
    zeynep.close();
  });

  // open zeynepjs side menu
  $(".btn-open").on("click", function () {
    zeynep.open();
  });
});
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".megamenu_more").forEach((button) => {
    button.addEventListener("click", function () {
      const targetClass = this.getAttribute("data-menu-open");
      const menuContent = document.querySelector(`.${targetClass}`);

      const padding = 24;
      const span = this.querySelector("span");

      if (menuContent.classList.contains("open")) {
        menuContent.style.maxHeight = null; // Collapse
        menuContent.classList.remove("open");
        span.textContent = "Show all";
        this.classList.remove("active");
      } else {
        menuContent.style.maxHeight =
          menuContent.scrollHeight + padding * 2 + "px"; // Expand
        menuContent.classList.add("open");
        span.textContent = "Show less";
        this.classList.add("active");
      }
    });
  });
});
